<template>

    <div class="music">
        <audio id="audio" :src="'../static/music/music.mp3'" autoplay="autoplay" loop preload="auto"></audio>
        <i class="el-icon-video-pause" @click="show_music($event)"></i>
        <i class="el-icon-medal" @click="drawer = true"></i>
        <el-dialog
                title=" "
                :visible.sync="drawer"
                :fullscreen ="true"
                :modal="false"
                :append-to-body="true"
                :lock-scroll="false"
                :width="'100%'">
            <div>
                <img style="width: 100%;height: 100%;" :src="'../static/images/BQ.png'" alt="">
            </div>
        </el-dialog>
    </div>


</template>

<script>
    export default {
        name: "Music",
        data:()=>{
           return{
               drawer: false,
               direction: 'rtl',
               isPlaying:true,
           }
         },
         mounted() {

             this.$nextTick(() => {
                 var state = 0;
                 var music = document.getElementById('audio');
                 document.addEventListener('touchstart', () => {
                     if(state===0){
                         music.play();
                         state=1;
                         console.log("duaio");
                     }
                 },false);

                 document.addEventListener("WeixinJSBridgeReady", function () {
                     music.play();
                     console.log("music");
                 }, false);

             });

/*             if (navigator.geolocation) {
                 confirm("水岸华庭需要获取您的位置");
             } else {
                 confirm("水岸华庭需要获取您的位置");
             }*/
         },
        methods:{
            show_music(e){
				var audio=document.querySelector('#audio');
				if(this.isPlaying){
					e.target.className='el-icon-video-play'
					audio.pause()
				}else{
					e.target.className='el-icon-video-pause'
					audio.play()
				}
				this.isPlaying=!this.isPlaying;
            },
            show_mianze(){
                this.$router.push("JG_DK")
            },
            show_position(){
                    if (navigator.geolocation) {
                        alert("您的浏览器浏览器支持获取地理位置信息。");
                    } else {
                        alert("您的浏览器浏览器不支持获取地理位置信息。");
                    }
            }

        }
    }
</script>

<style scoped>

.music{
    position: fixed;
    right: 30px;
    top: 11px;
    opacity: 0.9;
    z-index: 20;
}
audio{
    margin: 0;
    padding: 0;
}
.music i{
    font-size: 30px;
    color: rgba(233, 199, 138, 0.96);
    transform: scale(0.8,0.8);
	z-index: 999;
}
</style>





// WEBPACK FOOTER //
// src/components/Music.vue